import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import EventAddonItemUpsell from './EventAddonItemUpsell';
import withModal from '../modal/withModal';
import { ALBUM_SUBTYPE } from '../../../constants/albums';
import DismissButton from '../DismissButton';

export const EVENT_ADDON_ITEM_UPSELL_MODAL = 'modal/EVENT_ADDON_ITEM_UPSELL';

const propTypes = {
  albumSubtype: PropTypes.string,
  actionProps: PropTypes.shape({
    albumId: PropTypes.string,
    albumFolderId: PropTypes.string,
    onCheckoutSuccess: PropTypes.func,
    eventAddonItemType: PropTypes.string,
  }),
  onRequestClose: PropTypes.func.isRequired,
};

const EventAddonItemUpsellModal = ({
  actionProps = {},
  onRequestClose,
  albumSubtype: albumSubtypeProp = null,
}) => {
  const {
    albumId,
    albumFolderId,
    onCheckoutSuccess,
    eventAddonItemType,
    albumSubtype,
    featureId,
  } = actionProps;

  return (
    <div className="px-md-4 pb-md-4">
      <DismissButton
        onClick={() => {
          onRequestClose?.();
        }}
        className="wedding-event-purchase-dismiss"
      />

      <EventAddonItemUpsell
        albumId={albumId}
        albumFolderId={albumFolderId}
        eventAddonItemType={eventAddonItemType}
        albumSubtype={albumSubtype ?? albumSubtypeProp}
        onCheckoutSuccess={() => {
          onRequestClose();
          onCheckoutSuccess?.();
        }}
        featureId={featureId}
      />
    </div>
  );
};

EventAddonItemUpsellModal.propTypes = propTypes;

export default withModal(EventAddonItemUpsellModal, {
  name: EVENT_ADDON_ITEM_UPSELL_MODAL,
  size: 'sm',
  type: 'full',
  dismissible: false,
  getClassNames: ({ albumSubtype }) =>
    classNames({
      'event-addon-item-upsell-modal': true,
      'is-weddings': albumSubtype === ALBUM_SUBTYPE.WEDDINGS,
    }),
});
